<form (ngSubmit)="createFacebookFundraiser()" #f="ngForm" id="facebookFundraiserForm">
  <div class="modal-header facebook-fundraiser-modal-header">
    <h5 class="modal-title">Personalize your facebook fundraiser</h5>
  </div>
  <div class="modal-body facebook-fundraiser-modal-body pt-md-5 pb-md-5">
    <div class="form-group row mb-0 pt-2 pb-2">
      <label class="col-md-12 col-form-label"><strong>Title</strong></label>
      <div class="col-md-12">

        <div class="input-group">

          <input class="form-control ui-input-title"
                 name="title"
                 required
                 maxlength="70"
                 [(ngModel)]="title"
                 #titleControl="ngModel">
          <div class="form-control-error"
               *ngIf="!titleControl.valid && (titleControl.touched || state.isSubmitted)">
            <ul>
              <li *ngIf="titleControl?.errors?.required">Title is required.</li>
              <li *ngIf="titleControl?.errors?.maxlength">Can be up to 70 characters long.</li>
            </ul>
          </div>
        </div>

      </div>
    </div>
    <div class="form-group story-form-group row mb-0 pt-2 pb-2">
      <label class="col-md-12 col-form-label"><strong>Story</strong></label>
      <div class="col-md-12">

        <div class="input-group">

            <textarea class="form-control ui-input-story"
                   name="story"
                   required
                   maxlength="50000"
                   [(ngModel)]="story"
                   #storyControl="ngModel">
            </textarea>
            <div class="form-control-error"
                 *ngIf="!storyControl.valid && (storyControl.touched || state.isSubmitted)">
              <ul>
                <li *ngIf="storyControl?.errors?.required">Story is required.</li>
                <li *ngIf="storyControl?.errors?.maxlength">Can be up to 50k characters long.</li>
              </ul>
            </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer facebook-fundraiser-modal-footer">
    <div class="facebook-fundraiser-create-btn-wrapper">
      <button [disabled]="!canCallCreateFundraiserAction" form="facebookFundraiserForm" class="btn btn-primary create-facebook-fundraiser-btn">Create facebook fundraiser</button>
    </div>
    <div class="facebook-fundraiser-cancel-btn-wrapper">
      <a class="cancel-facebook-fundraiser-link"
         [ngClass]="{'disabled': !canCallCreateFundraiserAction}"
         (click)="closeModal()">Not now</a>
    </div>
  </div>
</form>